module.exports = __webpack_public_path__ + "img/Carli-Deysel.b6fa976e.png";